import { faSliders } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames"
import { useState } from "react"

export const CarsFilter = ({ setFilter }) => {

    const [showBrands, setShowbrands] = useState(false);
    
    const toggleBrands = () => setShowbrands((st) => !st)

    const brandsFilters = [
        {brand:'All', logo: '/logos/app-logo.png'},
        {brand:'Toyota', logo: '/logos/toyota.png'},
        {brand:'Nissan', logo:'/logos/nissan.png'},
        {brand: 'Jetour', logo: "/logos/jetour.png"},
        {brand: 'Mercedes', logo: "/logos/mercedes.png"},
        {brand: 'Mitsubishi', logo: '/logos/mitsubishi.png'},
        {brand: "Suzuki", logo: "/logos/suzuki.png"},
        {brand: "Jeep", logo: '/logos/jeep.png'},
        {brand: "Hyundai", logo: "/logos/hyundai.png"},
        {brand: "Honda", logo: "/logos/honda.png"}
    ];

    const handleSetFilter = (v) => {
        setFilter(v);
        setShowbrands(false);
    }

    return (
        <div className="filter-container">
            <div className="filter-buttons">
                <div className="filter-unit">
                    <button className="filter-button" onClick={toggleBrands}>
                        <FontAwesomeIcon icon={faSliders} />
                        <span className="filter-btn-cap">Brands</span>
                    </button>
                    <div className={classNames("brand-list", {"seen": showBrands})}>
                        {brandsFilters.map((brand,k) => (
                            <button 
                                className="brand-button"
                                onClick={() => handleSetFilter(brand.brand)}
                                key={k}
                            >
                                <img src={brand.logo} alt="" className="brand-logo" />
                                <span className="brand-title">{brand.brand}</span>
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}